export default __webpack_public_path__ + "cb502e266d1e1d2c7117b6297c684bf4.png";